/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Dispatch, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { cancel_button, confirm_buttom, confirm_p, popup_padding, save_button } from 'src/config/config'
import { useDeletePortfolioTagMutation } from 'src/graphql/manual/portfolioCustomTagHooks'
import { showToast } from 'src/store/actions/toastAction'

import { ModalCloseButton } from '../global/ModalCloseButton'

interface Props {
  isOpen: boolean
  tagId: string
  tagName: string
  onClose: () => void
  onSuccess: () => void
}

export const DeleteTagModal: React.FC<Props> = ({ isOpen, tagId, tagName, onClose, onSuccess }) => {
  const [deletePortfolioTag, { loading }] = useDeletePortfolioTagMutation()
  const dispatch: Dispatch<any> = useDispatch()

  useEffect(() => {
    if (!isOpen) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [isOpen, onClose])

  const handleDelete = async () => {
    if (loading) return
    try {
      const result = await deletePortfolioTag({ variables: { tagDocumentId: tagId } })
      onSuccess()
      onClose()

      if (result.data?.deletePortfolioTag) {
        setTimeout(() => {
          dispatch(showToast('Custom tag deleted successfully', 'success'))
        }, 700)
      }
    } catch (err: unknown) {
      // alert(err instanceof Error ? err.message : 'Failed to delete tag')
      dispatch(showToast(err instanceof Error ? err.message : 'Failed to delete tag', 'info'))
    }
  }

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="flex flex-col md:w-[620px] w-full md:pl-0 md:pr-0 pl-[10px] pr-[10px]"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="delete-tag-title"
        aria-modal="true"
      >
        <div className="flex flex-row w-full" style={{ zIndex: '10' }}>
          <ModalCloseButton onClose={onClose} className="md:top-[4px] top-[6px] md:right-[9px] right-[-12px]" />
        </div>
        <div className="flex flex-col overflow-hidden  md:w-[600px]  md:mr-[15px] mt-[-20px]">
          <div className={`request-contact-container  flex flex-row w-full ${popup_padding} md:w-[600px]`}>
            <div className={`${confirm_buttom}`}>
              <div className="flex items-center">
                <p className={`${confirm_p}  !pt-0`} style={{ height: 'auto' }}>
                  {'Delete Custom Tag'}
                </p>
              </div>

              <div className="h-[1px] bg-[#DDDDDD]"></div>
              <p className="mt-6 min-w-0 w-full text-[16px] font-secondary text-darkgray break-words">
                This will remove it from all solutions.
              </p>

              <p className="mt-6 flex items-center h-full text-[18px] font-bold font-secondary text-darkgray break-words">
                Are you sure you want to delete this custom tag?
              </p>

              <div className="mt-6 flex w-full min-w-0 flex-row flex-wrap items-center md:gap-[16px] gap-[8px]">
                <button
                  className={`${save_button}`}
                  type="button"
                  onClick={() => void handleDelete()}
                  disabled={loading}
                >
                  <p className="text-white">{loading ? 'Delete' : 'Delete'}</p>
                </button>

                <button className={`${cancel_button}`} type="button" onClick={onClose}>
                  <p className="text-[#333333]">Cancel</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
